/**
 * Device Detection Utilities for Skopic Mobile Web Experience
 */

export const isAndroid = () => {
  if (typeof window === "undefined" || !navigator) return false;
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  return /Android/i.test(userAgent);
};

export const isIOS = () => {
  if (typeof window === "undefined" || !navigator) return false;
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  const isAppleDevice = /iPhone|iPad|iPod/i.test(userAgent);
  // iPadOS 13+ detection (Desktop mode reporting MacIntel with touch support)
  const isiPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return isAppleDevice || isiPadOS;
};

export const isMobile = () => {
  if (typeof window === "undefined" || !navigator) return false;
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  const mobileRegex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileUA = isAndroid() || isIOS() || mobileRegex.test(userAgent);
  const isSmallScreen = typeof window !== "undefined" && window.innerWidth <= 768;
  return isMobileUA || isSmallScreen;
};

export const isDesktop = () => {
  return !isAndroid() && !isIOS();
};

export const isInAppBrowser = () => {
  if (typeof window === "undefined" || !navigator) return false;
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
  // Detect iOS Mail app WebKit view or in-app browsers
  const isIOSInApp = /iPhone|iPad|iPod/i.test(userAgent) && !/Safari/i.test(userAgent);
  const isGeneralInApp = /FBAN|FBAV|Instagram|GSA|Line|LinkedInApp|MicroMessenger|Pinterest|Twitter|FB_IAB/i.test(userAgent);
  return isIOSInApp || isGeneralInApp;
};

export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.inspira.skopic";
export const APP_STORE_URL = "https://apps.apple.com/app/id1551465962";

export const openSkopicApp = ({ communityName, emailActionData } = {}) => {
  const tenantId = emailActionData?.tenantId || "";
  const tenantName = communityName || emailActionData?.tenantName || "";
  const emailId = emailActionData?.emailId || "";
  const invitationToken = emailActionData?.invitationToken || emailActionData?.token || "";
  const inviterInfo = emailActionData?.inviterInfo || emailActionData?.inviterName || "";

  const params = new URLSearchParams();
  if (tenantId) {
    params.set("tenantId", tenantId);
    params.set("communityId", tenantId);
  }
  if (tenantName) {
    params.set("tenantName", tenantName);
    params.set("communityName", tenantName);
  }
  if (emailId) {
    params.set("emailId", emailId);
  }
  if (invitationToken) {
    params.set("invitationToken", invitationToken);
  }
  if (inviterInfo) {
    params.set("inviterInfo", inviterInfo);
  }

  const queryString = params.toString();

  if (isAndroid()) {
    const intentUrl = `intent://join${
      queryString ? `?${queryString}` : ""
    }#Intent;scheme=skopic;package=com.inspira.skopic;S.browser_fallback_url=${encodeURIComponent(
      PLAY_STORE_URL
    )};end`;
    window.location.href = intentUrl;
  } else if (isIOS()) {
    // Navigating directly to APP_STORE_URL on iOS prevents Safari from throwing the native
    // "Safari cannot open the page because the address is invalid" alert modal
    window.location.href = APP_STORE_URL;
  } else {
    window.location.href = PLAY_STORE_URL;
  }
};



